export const getCustomStyleErrors = (errors: { data: string | Responses.CustomStylesErrors }): Nullable<string> => {
  return typeof errors.data === 'string' ? null : errors.data.errors.customStyles;
};
